<template>
  <div
    class="maintenance-screen"
    role="alert"
    data-testid="maintenance-screen"
  >
    <div class="maintenance-screen--card">
      <!-- <span class="maintenance-screen--status" /> -->
      <!-- <q-icon
        class="maintenance-screen--icon"
        name="mono-gear"
      /> -->
      <q-spinner-gears class="maintenance-screen--spinner" />
      <h1 class="maintenance-screen--title">
        {{ t('Screen.title') }}
      </h1>
      <p class="maintenance-screen--message">
        {{ maintenance.message || t('Screen.message') }}
      </p>
      <p
        v-if="expectedEnd"
        class="maintenance-screen--expected"
      >
        {{ t('Screen.expectedEnd', { time: expectedEnd }) }}
      </p>
      <div class="maintenance-screen--footer">
        <span>{{ t('Screen.checking') }}</span>
        <Button
          :label="t('Screen.retry')"
          :loading="isMaintenanceFetching"
          size="sm"
          variant="outline"
          @click="refetchMaintenance()"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useMaintenanceStore } from '@/stores'
import { date as dateUtil } from 'quasar'
import { useTranslation } from 'i18next-vue'

import Button from '@/components/ui/Button/Button.vue'

defineOptions({ name: 'MaintenanceScreen' })

// Backend throttles api/maintenance at 60/min; 30s leaves plenty of headroom.
const POLL_INTERVAL_MS = 30_000

const { formatDate } = dateUtil

const { showMaintenance } = useMaintenanceStore()
const { maintenance } = storeToRefs(useMaintenanceStore())
const {
  isFetching: isMaintenanceFetching,
  refetch: refetchMaintenance
} = showMaintenance({ refetchInterval: POLL_INTERVAL_MS })
const { t } = useTranslation('maintenance')

// endsAt is the admin's estimate only — maintenance ends when an admin ends it.
const expectedEnd = computed(() => maintenance.value.endsAt
  ? formatDate(new Date(maintenance.value.endsAt), 'D MMM, HH:mm')
  : null)
</script>

<style scoped>
@reference "#app-styles.css";

.maintenance-screen {
  @apply fixed inset-0 z-6000 flex items-center justify-center p-md layer-base;
}
.maintenance-screen--card {
  /* max-w-md resolves to the project's --spacing-md token, not a container width */
  @apply flex flex-col items-start gap-sm w-full max-w-112 p-lg rounded-lg border edge-base layer-surf;
}
.maintenance-screen--spinner {
  @apply text-[24px] text-accent-mid animate-pulse;
  /* @apply size-2 rounded-full bg-warning-mid animate-pulse; */
}
.maintenance-screen--icon {
  @apply size-2 rounded-full bg-warning-mid animate-pulse;
}
.maintenance-screen--status {
  @apply size-2 rounded-full bg-warning-mid animate-pulse;
}
.maintenance-screen--title {
  @apply m-0 text-lg font-medium leading-snug ink-strong;
}
.maintenance-screen--message {
  @apply m-0 text-sm ink-soft whitespace-pre-line;
}
.maintenance-screen--expected {
  @apply m-0 text-xs ink-subtle;
}
.maintenance-screen--footer {
  @apply flex items-center justify-between gap-sm w-full mt-sm pt-sm border-t edge-base text-xs ink-muted;
}
</style>
